import { isNumberGreaterThanZero } from '@thesavingsgroup/utils/isNumberGreaterThanZero';

import { MailCodeOfferField } from '../types/MailCodeOfferField';
import { MailCodeOfferValues } from '../types/MailCodeOfferValues';

export const toMissingOfferFields = (
  requiredOfferFields: MailCodeOfferField[],
  offerValues: MailCodeOfferValues | undefined,
): MailCodeOfferField[] =>
  requiredOfferFields.filter(
    (field): boolean => !isNumberGreaterThanZero(offerValues?.[field]),
  );
